import { _ as n } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import { styled as r, css as t } from "styled-components";
import { Button as m } from "./button.js";
var s, a, p, w = r.div(s || (s = n([`
  &.ShowMoreLessWrapper {
    `, `
  }
`])), function(e) {
  var o = e.theme.components.showMoreLess;
  return t(o.ShowMoreLessWrapper);
}), M = r.div(a || (a = n([`
  &.BodyContentContainer {
    `, `;
  }
`])), function(e) {
  var o = e.theme.components.showMoreLess;
  return t(o.BodyContentContainer);
}), c = r(m)(p || (p = n([`
  &.ShowMoreLessContainer {
    `, `
  }
`])), function(e) {
  var o = e.theme.components.showMoreLess;
  return t(o.ShowMoreLessContainer);
});
export {
  M as B,
  w as S,
  c as a
};
